import { useCheckin } from './CheckinContext'
import LinhaEditavelCard from './LinhaEditavelCard'

const ProdutosCard = ({ preencherAltura }) => {
  const { listaProdutos, updateProduto } = useCheckin()

  return (
    <LinhaEditavelCard
      titulo="Produtos adicionais"
      lista={listaProdutos}
      onUpdateItem={updateProduto}
      comSolicitado
      preencherAltura={preencherAltura}
      mostrarPaciente
      compactarSimboloMoeda
    />
  )
}

export default ProdutosCard
